import * as React from 'react';

const SvgFilter = React.forwardRef(({ size = 24, ...props }, ref) => (React.createElement("svg", { "data-testid": "svg-filter", xmlns: "http://www.w3.org/2000/svg", width: size, height: size, fill: "none", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M7 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M10 17a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1", clipRule: "evenodd" }))));
SvgFilter.displayName = 'SvgFilter';

export { SvgFilter };
